<template>
<div class="content-body tenant-settings">
    <div class="">
        <div>
            <el-row><span style="color:red">即使使用同一种材料，也请按照零部件单位分开填写</span></el-row>
        </div>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <!-- <el-form-item label="报价轮次:">
                <el-input size="mini" v-model="dataForm.roundNo" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="原材料:">
                <el-input size="mini" v-model="dataForm.rawMaterial" clearable></el-input>
            </el-form-item>
            <el-form-item class="fr">
              <el-button size="mini" :loading="saveDisabled" type="primary" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  plain @click="save()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
              </el-button>
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
<!--                <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">-->
<!--                    新建-->
<!--                </el-button>-->
              <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addHandleNewRow()" icon="el-icon-plus">
                新增
              </el-button>
            </el-form-item>
        </el-form>
      <el-table-edit
          v-model="dataList"
          :columns="['partCode','partName', 'rawMaterial','supplierName','priceCost'
          ,'weight','materialTotal','wasteCost','wasteWeight','wasteTotal','lastTotal','roundNo']"
          ref="editTable"
      >
        <el-table
            :data="dataList" row-key="index" size="mini" border style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}"
                  :default-expand-all="false" :height="tableHeight">
            <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                </template>
            </el-table-column>
            <el-table-column prop="partCode" width="150" header-align="center" align="left" label="零件号" fixed>
              <template slot-scope="{ row }">
                <el-table-edit-cell
                    :row="row"
                    prop="partCode"
                >
                  <template slot-scope="{ rowStates }">
                    <span v-show="!rowStates.editing">{{row.partCode}}</span>
                    <el-input
                        size="mini"
                        v-show="rowStates.editing"
                        v-model="row.partCode"
                        clearable
                    >
                    </el-input>
                  </template>
                </el-table-edit-cell>
              </template>
            </el-table-column>
            <el-table-column prop="partName" width="150" header-align="center" align="left" label="零件名称" fixed>
              <template slot-scope="{ row }">
                <el-table-edit-cell
                    :row="row"
                    prop="partName"
                >
                  <template slot-scope="{ rowStates}">
                    <span v-show="!rowStates.editing">{{row.partName}}</span>
                    <el-input
                        size="mini"
                        v-show="rowStates.editing"
                        v-model="row.partName"
                        clearable
                    >
                    </el-input>
                  </template>
                </el-table-edit-cell>
              </template>
            </el-table-column>
            <el-table-column label="详细状况" align="center">
                <el-table-column prop="rawMaterial" width="150" header-align="center" align="left" label="原材料">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="rawMaterial"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.rawMaterial}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.rawMaterial"
                            clearable
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
              <el-table-column prop="supplierName" width="150" header-align="center" align="left" label="供应商">
                <template slot-scope="{ row }">
                  <el-table-edit-cell
                      :row="row"
                      prop="supplierName"
                  >
                    <template slot-scope="{ rowStates }">
                      <span v-show="!rowStates.editing">{{row.supplierName}}</span>
                      <el-input
                          size="mini"
                          v-show="rowStates.editing"
                          v-model="row.supplierName"
                          clearable
                      >
                      </el-input>
                    </template>
                  </el-table-edit-cell>
                </template>
              </el-table-column>
                <el-table-column prop="priceCost" width="150" header-align="center" align="right" label="原材料价格元/Kg(A)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="priceCost"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.priceCost | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.priceCost" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="weight" width="150" header-align="center" align="right" label="投入重量 Kg/个(B)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="weight"
                    >
                      <template slot-scope="{ rowStates }">
                          <span v-show="!rowStates.editing">{{row.weight | digit4}}</span>
                        <ctl-number :precision="4" :p="4" :min="0" v-show="rowStates.editing" v-model="row.weight" maxlength="200"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
              <el-table-column prop="materialTotal" width="150" header-align="center" align="right" label="原材料小计(C=A×B)">
                <template slot-scope="{ row }">
                  <span>{{row.materialTotal | digit3}}</span>
                </template>
              </el-table-column>
                <el-table-column label="废料计算" align="center">
                    <el-table-column prop="wasteCost" width="150" header-align="center" align="right" label="废料价格(D)">
                      <template slot-scope="{ row }">
                        <el-table-edit-cell
                            :row="row"
                            prop="wasteCost"
                        >
                          <template slot-scope="{ rowStates }">
                            <span v-show="!rowStates.editing">{{row.wasteCost | digit3}}</span>
                            <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.wasteCost" maxlength="200"></ctl-number>
                          </template>
                        </el-table-edit-cell>
                      </template>
                    </el-table-column>
                    <el-table-column prop="wasteWeight" width="150" header-align="center" align="right" label="废料重量 Kg/个(E)">
                      <template slot-scope="{ row }">
                        <el-table-edit-cell
                            :row="row"
                            prop="wasteWeight"
                        >
                          <template slot-scope="{ rowStates }">
                            <span v-show="!rowStates.editing">{{row.wasteWeight | digit3}}</span>
                            <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.wasteWeight" maxlength="200"></ctl-number>
                          </template>
                        </el-table-edit-cell>
                      </template>
                    </el-table-column>
                    <el-table-column prop="wasteTotal" width="150" header-align="center" align="right" label="废料小计(F=D×E)">
                      <template slot-scope="{ row }">
                        <span>{{row.wasteTotal | digit3}}</span>
                      </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="lastTotal" width="150" header-align="center" align="right" label="小计(G=C-F)">
                  <template slot-scope="{ row }">
                    <span>{{row.lastTotal | digit3}}</span>
                  </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="roundNo" width="150" header-align="center" align="right" label="报价轮次">
            </el-table-column>
            <el-table-column header-align="center" align="left" width="190" label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text"  v-show="scope.row.id !==''"  size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                        查看
                    </el-button>
                    <el-button type="text"  v-show="scope.row.id !==''"  size="small" :disabled="viewFlag != 'view'? false :true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
      </el-table-edit>
        <!-- 分页 -->
        <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination> -->

      <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshMateralDataList="getDataList" @getDataListAll="getDataListAll"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    addPartPrice,
    editPartPrice,
    quotationMateralList,
    quotationMateralDelete,
    quotationMateralInsertBatch,
    quotationMateralUpdateBatch,
    getQuotationDetail
} from '@/controller/quotation'
import AddOrUpdate from './quotationMateral-add-or-update'
import moment from 'moment'
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockQuotation');
export default {
    props: {
        roundNo: Number,
        dataFromParent: Object
    },
    data() {
        return {
            rowNum:1,
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                priceCost: 0,
            },
            viewFlag: '',
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            saveDisabled:false,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    components: {
        AddOrUpdate,
        CtlNumber
    },
    filters:{
      digit3:function (data){
          if (data  ==0 ){
            return data
          }
          data = Number(data).toFixed(3)
          if(Number.isNaN(Number(data))){
            return null
        }
        return Number(data)
        },
      digit4:function (data){
        data = Number(data).toFixed(4)
        if(Number.isNaN(Number(data))){
            return null
        }
         return Number(data)
      }
    },
    computed: {
      editTable() {
        return this.$refs.editTable
      },
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    // activated() {
    //     this.getDataList()
    // },
    methods: {
      //新一行
      getNewRowData() {
        return {
          'id':'',
          'rfqId': this.dataForm.rfqId,
          'rfqPartId': this.dataForm.rfqPartId,
          'rfqSupplierId': this.dataForm.rfqSupplierId,
          'partCode':'',
          'partName':'',
          'rawMaterial':'',
          'supplierName':'',
          'priceCost':0,
          'weight':0,
          'materialTotal':'',
          'wasteCost':'',
          'wasteWeight':0,
          'wasteTotal':0,
          'lastTotal':'',
          'roundNo':this.dataForm.roundNo!==null ? this.dataForm.roundNo:'0',
          'rowNum':this.rowNum

        }
      },
      // 新增行
      addHandleNewRow() {
        const newRow = this.getNewRowData()
        this.editTable.newRows([newRow])
        this.rowNum += 1
      },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        // 新增或编辑子节点
        addChildHandle(id, parentId, parentName, parentNodePath) {
            console.log(id, parentId, parentName, parentNodePath)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
            })
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        fixedNumber(val) {
            if (!val || isNaN(val)) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        saveSum(dataListAll){
            //console.log("dataFromParent.rfqId",this.dataFromParent.rfqId)
            let sum = 0;
            if(dataListAll.length !== 0){
                dataListAll.forEach((item) => {
                    sum += this.fixedNumber(item.lastTotal);
                });
            }
            //console.log("2222222222222")
            let params = this.dataFromParent
            //console.log("params",params)
            params.rfqId = this.dataFromParent.rfqId
            //console.log("params.rfqId",params.rfqId)
            params.materialCost = sum
            // 制造成本小计(D=A+B+C)
            params.productionCostSum = this.fixedNumber(params.materialCost) + this.fixedNumber(params.outsidePartCost) 
                + this.fixedNumber(params.processingCost)
            // 产品单价(J=D+H+I+K+L)
            params.productUnitPrice = this.fixedNumber(params.productionCostSum) + this.fixedNumber(params.midiumCostSum)
                + this.fixedNumber(params.profit) + this.fixedNumber(params.packageFee) 
                + this.fixedNumber(params.transportFee) 
                //console.log(params.productUnitPrice);
            // 产品价格总计
            params.feeCostSum = this.fixedNumber(params.productUnitPrice) + this.fixedNumber(params.toolsPartAllocation)
                + this.fixedNumber(params.designPartAllocation) 
            if (params.id) {
                editPartPrice(params).then(data => {
                    if (data && data.code === '00') {
                        // this.dataForm.id = data.body.id;
                        // this.dataForm = data.body;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }else{
                addPartPrice(params).then(data => {
                    if (data && data.code === '00' && data.body) {
                        this.dataFromParent.id = data.body.id;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 获取数据列表
        getDataListAll() {
            //console.log("11111")
            this.dataListLoading = true
            quotationMateralList({
                pageNo: 1,
                pageSize: -1,
                // totalPage: this.totalPage,
                ...this.dataForm
            }).then(data => {
                if (data && data.code === '00') {
                    //console.log("3333333333333333333333")
                    this.saveSum(data.body.records)
                }
                this.dataListLoading = false
            })
        },
        //保存
        save(){
        var ins =[]
          var upd=[]
          this.dataList.forEach(value => {
            if (value.id !==''){
              upd.push(value)
            }else {
              ins.push(value)
            }
          })
          if (ins.length > 0 ){
            var params = {
              "list":ins,
              "rfqId": this.dataForm.rfqId,
              "subcompanyId": this.dataFromParent.subcompanyId
            }
            this.saveDisabled = true
            //console.log('this.dataForm.rfqId',this.dataForm.rfqId)
            quotationMateralInsertBatch(params).then((data) => {
              if (data && data.code === "00") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                });
                this.$nextTick(() => {
                   //console.log("222222222")
                   this.getDataListAll();
                })
              } else {
                this.$message.error(data.msg);
              }
              this.getDataList()
              setTimeout(() => {
                this.saveDisabled = false
                }, 3000)
            })
          }
          // if (upd.length > 0 ){
          //   var params = {
          //     "list":upd
          //   }
          //   quotationMateralUpdateBatch(params).then((data) => {
          //     if (data && data.code === "00") {
          //       this.$message({
          //         message: "操作成功",
          //         type: "success",
          //         duration: 1500,
          //         onClose: () => {
          //           this.view.visible = false;
          //         },
          //       });
          //     } else {
          //       this.$message.error(data.msg);
          //     }
          //   })
          //       .catch((error) => {
          //         console.log(error);
          //       });
          // }
          // this.getDataList()



        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            quotationMateralList({
                pageNo: 1,
                pageSize: -1,
                // totalPage: this.totalPage,
                ...this.dataForm
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 删除
        deleteHandle(row) {
          console.log('row', row)
          if (row.id !== ''){
            //检查rfq状态，已开标则不能删除
            if (row && row.rfqId) {
                getQuotationDetail({}, row.rfqId).then(data => {
                     console.log(data)
                     if (data && data.code === '00') {
                         if("2" != data.body.rfqStatus) {
                             this.$message.warning("询价单不是询价中状态，不允许删除报价相关信息")
                         } else {
                             //已保存的行
                             this.$confirm(`确定进行删除操作?`, '提示', {
                               confirmButtonText: '确定',
                               cancelButtonText: '取消',
                               type: 'warning'
                             }).then(() => {
                               quotationMateralDelete({}, row.id).then(data => {
                                 if (data && data.code === '00') {
                                   this.$message({
                                     message: '操作成功',
                                     type: 'success',
                                     duration: 1500,
                                     onClose: () => {
                                       this.getDataList()
                                     }
                                   })
                                     this.$nextTick(() => {
                                         this.getDataListAll();
                                     })
                                 } else {
                                   this.$message.error(data.msg)
                                 }
                               })
                             })
                         }
                     }
                })
            }
          }else {
            //未保存的 直接删除行
            // console.log(JSON.stringify(row))
            var a = []
            a.push(row)
            this.editTable.delRows(a)
          }

        }
    }
}
</script>

<style lang="scss">
.fr {
    float: right;
}

.button-danger {
    color: #F56C6C;
}
</style>
